import { render } from "./BarRight.vue?vue&type=template&id=0684adf1&scoped=true"
import script from "./BarRight.vue?vue&type=script&lang=js"
export * from "./BarRight.vue?vue&type=script&lang=js"

import "./BarRight.vue?vue&type=style&index=0&id=0684adf1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0684adf1"]])

export default __exports__